import * as yup from 'yup';
import { useFormHandler } from './useFormHandler';

export type HighlightsFormValues = {
  term: string;
  definition: string;
};

const highlightsFormValidationSchema = yup.object({
  term: yup.string().required('Le terme est obligatoire'),
  definition: yup.string().required('La définition est obligatoire'),
});

export const useHighlightsForm = () => {
  const {
    register,
    handleSubmit,
    errors,
    setValue,
    reset,
    control,
    getValues,
  } = useFormHandler<HighlightsFormValues>(highlightsFormValidationSchema);

  return {
    register,
    handleSubmit,
    errors,
    setValue,
    reset,
    control,
    getValues,
  };
};
